
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="card-wrapper type-modal" [formGroup]="debtForm">
    <div class="card">
      <h3 class="green decoration mb-4">Detalles de la deuda</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('organization_id').dirty && debtForm.get('organization_id').invalid">
        <span>Comercio:</span>
        <input type="text" formControlName="organization_id" [attr.disabled]="true">
        <p *ngIf="debtForm.get('organization_id').dirty && debtForm.get('organization_id').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('organization_id').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('name_organization').dirty && debtForm.get('name_organization').invalid">
        <span>Nombre del comercio:</span>
        <input type="text" formControlName="name_organization" [attr.disabled]="true">
        <p *ngIf="debtForm.get('name_organization').dirty && debtForm.get('name_organization').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('name_organization').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('date').dirty && debtForm.get('date').invalid">
        <span>Fecha:</span>
        <input type="text" formControlName="date" [attr.disabled]="true">
        <p *ngIf="debtForm.get('date').dirty && debtForm.get('date').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('date').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
    <div class="card">
      <h3 class="green" style="margin-bottom: 1.6rem;">&nbsp;</h3>
      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('amount').dirty && debtForm.get('amount').invalid">
        <span>Monto:</span>
        <input type="text" formControlName="amount" [attr.disabled]="true">
        <p *ngIf="debtForm.get('amount').dirty && debtForm.get('amount').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('amount').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('status').dirty && debtForm.get('status').invalid">
        <span>Status:</span>
        <input type="text" formControlName="status" [attr.disabled]="true">
        <p *ngIf="debtForm.get('status').dirty && debtForm.get('status').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('status').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="debtForm.get('balance').dirty && debtForm.get('balance').invalid">
        <span>Balance:</span>
        <input type="text" formControlName="balance" [attr.disabled]="true">
        <p *ngIf="debtForm.get('balance').dirty && debtForm.get('balance').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="debtForm.get('balance').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
  </div>
  <div class="card" style="padding-top: 12px;">
    <h3 class="mb-4">Items</h3>
    <app-custom-table-min [displayedColumns]="displayedColumns" [data]="dataSource" [customH]="'custom-1'"></app-custom-table-min>
  </div>
  <div class="card" style="padding-top: 12px;">
    <h3 class="mb-4">Pagos</h3>
    <app-custom-table-min [displayedColumns]="displayedColumns2" [data]="dataSource2" [customH]="'custom-1'"></app-custom-table-min>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="newPaymentFromId()" class="btn btn-gray big">Nuevo pago</button>
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
